import { CommonHelperFunctions, IFeedback } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class FeedBackService {
  public static async CreateTicket(model: IFeedback): Promise<AxiosResponse> {
    try {
      return await Axios.post<IFeedback, AxiosResponse>(`${backendUrl}/ZendeskAPI/ZendeskCreateTicket`, model);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
